import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';

class DeliveryDayTimeRanges extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      timeRanges: props.formData,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      timeRanges: nextProps.formData,
    });
  }

  onChange(index, fieldName) {
    return (event) => {
      const newTimeRanges = this.state.timeRanges;
      newTimeRanges[index][fieldName] = event.target.value;

      this.setState(
        {
          timeRanges: newTimeRanges,
        },
        () => this.props.onChange(this.state.timeRanges)
      );
    };
  }

  onB2bCheckboxChange(index) {
    return () => {
      const newTimeRanges = [...this.state.timeRanges];
      newTimeRanges[index]['isBusinessToBusiness'] = !newTimeRanges[index]['isBusinessToBusiness'];

      this.setState(
        {
          timeRanges: newTimeRanges,
        },
        () => this.props.onChange(this.state.timeRanges)
      );
    };
  }

  render() {
    return (
      <div>
        <legend>
          <FormattedMessage id={'time.ranges.form.field.legend'} />
        </legend>

        {this.state.timeRanges.map((timeRange, index) => {
          return (
            <div key={index} className="delivery-day-form__time-ranges">
              <div className="row">
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.from.hour.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.fromHour}
                      onChange={this.onChange(index, 'fromHour')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.from.minutes.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.fromMinutes}
                      onChange={this.onChange(index, 'fromMinutes')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.to.hour.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.toHour}
                      onChange={this.onChange(index, 'toHour')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.to.minutes.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.toMinutes}
                      onChange={this.onChange(index, 'toMinutes')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.remaining.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={timeRange.remaining}
                      onChange={this.onChange(index, 'remaining')}
                    />
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.time.ranges.field.service.area.id.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      disabled={true}
                      value={timeRange.serviceAreaName}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group m-b-2">
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={timeRange.isBusinessToBusiness}
                          onChange={this.onB2bCheckboxChange(index)}
                        />{' '}
                        <FormattedMessage
                          id={'service.area.form.field.time.ranges.field.is.business.to.business.label'}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default injectIntl(DeliveryDayTimeRanges);
